
import { IDataProviderRequest } from "@/interfaces/data-provider";
import { useCatalog, useMetadataCatalog } from "@/store";
import { defineComponent } from "@vue/composition-api";
import { zipObject } from "lodash";
import { mapState } from "pinia";
import config from "@/util/constants";

export default defineComponent({
  name: "AddDataRefCat",
  data: () => ({
    dataCatTbl: new Array<any>(),
    refTypeTbl: new Array<any>(),
    dpRequest: {} as IDataProviderRequest,
    fields: new Array<string>(),
    items: new Array<any>(),

    // dataRefCatTblN: "data_reference_cat",
    // dataCatTblN: "data_cat",
    // refTypeTblN: "reference_type",
    // tblPath: "/data_mgmt/all/System/",

    dataRefCatTblN: config.metaCat.v_data_reference_cat,
    dataCatTblN: config.metaCat.v_data_cat,
    refTypeTblN: config.metaCat.v_reference_type,
    tblPath: "/meta_cat/",

    dataCatEntry: {
      data_cat_id: { val: null, type: Number, isRequired: true },
      ref_data_cat_id: { val: null, type: Number, isRequired: true },
      reference_type_id: { val: null, type: Number, isRequired: true },
      created_date: { val: null, type: String, isRequired: false },
    },
  }),
  computed: {
    ...mapState(useCatalog, ["tableMeta", "tableData"]),
    ...mapState(useMetadataCatalog, ["dataRefCatUri", "selectedDataCatId"]),
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    async resetVar() {
      this.dataCatEntry.ref_data_cat_id.val = null;
      this.dataCatEntry.reference_type_id.val = null;
      this.dataCatEntry.created_date.val = null;
      return true;
    },
    async init() {
      this.dataCatEntry.data_cat_id.val = this.selectedDataCatId;
      this.dpRequest.orderBys = [
        { columnName: "data_cat_id", keyword: "desc" },
      ];
      await this.catalogChange(this.dataCatTblN);
      this.dpRequest.orderBys = [];
      await this.catalogChange(this.refTypeTblN);
    },
    async loadData(tableName: string, columns: Array<string>) {
      await useCatalog()
        .getTableData({
          catalogUri: this.tblPath + tableName,
          request: this.dpRequest,
        })
        .then(() => this.setTableData(tableName, columns));
    },
    setTableData(tableName: string, columns: Array<string>) {
      if (this.tableData?.rows.length) {
        switch (tableName) {
          case this.dataCatTblN:
            this.dataCatTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.refTypeTblN:
            this.refTypeTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          default:
            this.showMessage(
              "danger",
              "Couldn't find the matching table name!! - " + tableName
            );
            break;
        }
      }
    },
    async catalogChange(tableName: string) {
      // Retrieve table meta
      await useCatalog()
        .getTableMeta({
          catalogUri: this.tblPath + tableName,
          request: {},
        })
        .then(() => {
          this.setTableColumns(tableName);
        });
    },
    setTableColumns(tableName: string) {
      if (this.tableMeta?.columns.length) {
        let columns = this.tableMeta.columns.map(
          (c: { columnName: string }) => c.columnName
        );
        this.loadData(tableName, columns);
      }
    },
    async updateDB(param: string) {
      const methodN = "updateDB";
      const requestFrom = "data_ref_cat";
      const nextPage = "update_cat";
      const catUri = this.tblPath + this.dataRefCatTblN;

      this.$emit(
        methodN,
        requestFrom,
        param,
        this.dataCatEntry,
        nextPage,
        catUri,
        this.dataRefCatUri
      );
    },
    showMessage(type: string, msg: string) {
      this.$root.$emit("showAlert", 4, type, msg);
    },
  },
});
